import { PostSeenData, PostsSentToSES, StorySeenData, StorySentToSES } from '../actions/fleekState';
import { fleekActions, storyActions } from '../actionTypes';

interface initialStateType {
  seenPostsBuffer: PostSeenData[];
  postsSentToSES: PostsSentToSES[];
  showSplashScreen: boolean;
  showCoachMarkScreen: boolean;
  scrollPositionFeed: number;
  scrollPositionExplore: number;
  postLiked: { [postId: string]: boolean };
  postLikeCount: { [postId: string]: number };
  brandFollowed:{[brandId: string]: boolean };
  seenStories: StorySeenData[];
  storiesSentToSES: StorySentToSES[];
  wishListOptionsCodeUpdated: boolean;
}

const initalState: initialStateType = {
  seenPostsBuffer: [],
  seenStories: [],
  postsSentToSES: [],
  showSplashScreen: true,
  showCoachMarkScreen: true,
  scrollPositionFeed: 0,
  scrollPositionExplore: 0,
  postLiked: {},
  postLikeCount:{},
  brandFollowed:{},
  storiesSentToSES: [],
  wishListOptionsCodeUpdated: false
};

interface ActionType {
  type: string;
  payload: any;
}

const fleekStateReducer = (state = initalState, action: ActionType) => {
  switch (action.type) {
    case fleekActions.POST_SEEN:
      return {
        ...state,
        seenPostsBuffer: [...state.seenPostsBuffer, action.payload]
      };

    case fleekActions.RESET_POST_SEEN:
      return {
        ...state,
        seenPostsBuffer: []
      };
    case fleekActions.POSTS_SEND_TO_SES:
      return {
        ...state,
        postsSentToSES: [...state.postsSentToSES, ...action.payload]
      };

    case storyActions.SUB_STORY_SEEN:
      console.log('subStory Seeen')
      return {
        ...state,
        seenStories: [...state.seenStories, action.payload.data]
      };

    case storyActions.RESET_STORY_SEEN:
      return {
        ...state,
        seenStories: []
      };

    case storyActions.STORYS_SEND_TO_SES:
      return {
        ...state,
        storiesSentToSES: [...state.storiesSentToSES, ...action.payload]
      };

    case fleekActions.SHOW_SPLASH_SCREEN:
      return {
        ...state,
        showSplashScreen: action.payload
      };

      case fleekActions.SHOW_COACHMARK_SCREEN:
      return {
        ...state,
        showCoachMarkScreen: action.payload
      };

      case fleekActions.WISHILIST_OPTIONS_CODE_UPDATED:
      return {
        ...state,
        wishListOptionsCodeUpdated: action.payload
      };
    case fleekActions.UPDATE_FEED_SCROLL_POSITION:
      return {
        ...state,
        scrollPositionFeed: action.payload
      };

    case fleekActions.UPDATE_EXPLORE_SCROLL_POSITION:
      return {
        ...state,
        scrollPositionExplore: action.payload
      };

    case fleekActions.POST_LIKED:
      return {
        ...state,
        postLiked: { ...state.postLiked, [action.payload.postId]: action.payload.isLiked },
        postLikeCount: {...state.postLikeCount, [action.payload.postId]: action.payload.likeCount}
      };

      case fleekActions.BRAND_FOLLOWED:
        return {
          ...state, 
          brandFollowed:{...state.brandFollowed, [action.payload.brandId]:action.payload.isFollowed}
        }

    default:
      return state;
  }
};

export default fleekStateReducer;
